import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles((theme: any) => ({
  deleteStage: { color: theme.palette.lightBlack },
}));

interface Props {
  id: string;
  handleStageUpdate: (...args) => void;
}
export default function MobileDeleteStage({ id, handleStageUpdate }: Props) {
  const classes = useStyles();

  function handleClick() {
    handleStageUpdate(id, 'deleted', true);
  }

  return (
    <IconButton onClick={handleClick} className={classes.deleteStage}>
      <DeleteIcon />
    </IconButton>
  );
}
